import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-panel box-shadow" }
const _hoisted_2 = { class: "controller-content tabs-content" }
const _hoisted_3 = { class: "controller-tabs" }
const _hoisted_4 = { class: "controller-tabs-icons" }
const _hoisted_5 = ["id", "onClick"]

import { computed, inject, markRaw, ref, watch } from "vue";
  import { trans } from "@/utils/trans";
  import {
    Chat,
    Statistic,
    Currency,
    History,
    LockBidding,
    Users,
    Setting,
    Network
  } from "@/components/action-block/tabs";
  import LiveBidBlock from "@/components/action-block/LiveBidBlock.vue";
  import {
    MailLiveIcon,
    HistoryIcon,
    ConverterCurrencyIcon,
    StatisticIcon,
    BaseIcon,
    LockIcon,
    CogIcon,
    WifiIcon,
    UsersIcon
  } from "@/components/icons";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { AuctionStatuses } from "@/enum";
  import { isScreenL } from "@/utils/media-size";
  import { AuthPopup } from "@/components/_partials/lot-info-popup";

  const defaultViewBox = "0 0 24 24";
  const chatTabKey = "chat";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsTab',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const authPopupRef = ref<HTMLDivElement>(null);

  const emitter = inject("emitter");
  const initIsScreenL = isScreenL.value;

  const auctionStatus = computed(() => auctionStore.auction.status);

  const chatObject = {
    key: chatTabKey,
    iconName: "mail-live",
    icon: markRaw(MailLiveIcon),
    iconViewBox: "0 0 22.636 18.109",
    component: markRaw(Chat)
  };
  const statisticObject = {
    key: "statistics",
    iconName: "statistics",
    icon: markRaw(StatisticIcon),
    iconViewBox: "0 0 20.121 20.121",
    component: markRaw(Statistic)
  };
  const lockObject = {
    key: "lock",
    iconName: "lock",
    icon: markRaw(LockIcon),
    iconViewBox: "0 0 17.721 23.259",
    component: markRaw(LockBidding),
    isNeedAuth: true
  };
  const tabs = computed(() => {
    const tabs = [];

    if (auctionStore.user?.is_admin) {
      tabs.push(
        {
          key: "users",
          iconName: "users",
          icon: markRaw(UsersIcon),
          iconViewBox: "0 0 24 16.8",
          component: markRaw(Users)
        },
        chatObject,
        statisticObject,
        {
          key: "setting",
          iconName: "setting",
          icon: markRaw(CogIcon),
          iconViewBox: "0 0 26 25.871",
          component: markRaw(Setting)
        },
        {
          key: "wifi",
          iconName: "wifi",
          icon: markRaw(WifiIcon),
          iconViewBox: "0 0 22 15.552",
          component: markRaw(Network)
        }
      );
    } else {
      if (auctionStatus.value !== AuctionStatuses.ENDED) {
        tabs.push(
          {
            key: "history",
            iconName: "history",
            icon: markRaw(HistoryIcon),
            iconViewBox: "0 0 22.637 22.636",
            component: markRaw(History),
            class: "mob-hidden"
          },
          chatObject,
          {
            key: "converter-currency",
            iconName: "converter-currency",
            icon: markRaw(ConverterCurrencyIcon),
            iconViewBox: "0 0 21.685 21.684",
            component: markRaw(Currency)
          }
        );

        tabs.push(statisticObject);

        if (!initIsScreenL) {
          tabs.push(lockObject);
        }
      } else {
        tabs.push(statisticObject);
      }
    }

    return tabs;
  });

  const activeTab = ref(
    auctionStatus.value === AuctionStatuses.ENDED ? tabs.value[0].key : tabs.value[isScreenL.value ? 1 : 0].key
  );
  watch(
    () => auctionStore.hasNewChatMessage,
    () => {
      const chatTab = getChatTab();
      if (chatTab) {
        addBlinkingToTab(chatTab);
      }
    }
  );

  watch(
    () => auctionStore.pageIsActive,
    (isPageActiveNV) => {
      const chatTab = getChatTab();
      if (chatTab) {
        if (auctionStore.hasNewChatMessage && !isPageActiveNV) {
          addBlinkingToTab(chatTab);
        } else {
          setTimeout(() => removeBlinkingToTab(chatTab), 3000);
        }
      }
    }
  );

  watch(isScreenL, (newValue) => {
    activeTab.value = newValue && activeTab.value === "history" ? tabs.value[1].key : tabs.value[0].key;
    if (!newValue && auctionStore.user && auctionStatus.value !== AuctionStatuses.ENDED) {
      tabs.value.push(lockObject);
    } else {
      let index = tabs.value.findIndex((item) => item.key === "lock");
      if (index !== -1) {
        tabs.value.splice(index, 1);
      }
    }
  });

  const getChatTab = (): HTMLElement | null => {
    return document.getElementById(`${chatTabKey}Ref`);
  };

  emitter?.on("on:user-message", () => {
    activeTab.value = chatTabKey;
  });

  const addBlinkingToTab = (tab: HTMLElement) => {
    tab.classList.add("blinking");
  };

  const removeBlinkingToTab = (tab: HTMLElement) => {
    tab.classList.remove("blinking");
  };
  const changeActiveTab = (tab) => {
    if (tab.isNeedAuth && !auctionStore.user?.id) {
      authPopupRef.value?.open();
    } else {
      activeTab.value = tab.key;
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "options-sidebar",
      class: _normalizeClass([
      'site-tabs options-sidebar',
      `status-${auctionStatus.value.toLowerCase()}`,
      { 'auction-not-started': auctionStatus.value === _unref(AuctionStatuses).ACTIVE }
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-content", [tab.class || '', { active: activeTab.value === tab.key }]]),
              key: tab.key
            }, [
              _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(tab.component), {
                "is-visible": activeTab.value === tab.key,
                onChangeTab: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event)),
                id: `${tab.key}RefComponent`
              }, null, 40, ["is-visible", "id"])), [
                [_vShow, activeTab.value === tab.key]
              ])
            ], 2))
          }), 128))
        ]),
        (!_unref(auctionStore).user?.is_admin && auctionStatus.value !== _unref(AuctionStatuses).ENDED)
          ? (_openBlock(), _createBlock(LiveBidBlock, {
              key: 0,
              onChangeTab: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = $event))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-title", [tab.class || '', { active: activeTab.value === tab.key }]]),
              key: tab.key,
              id: `${tab.key}Ref`,
              onClick: ($event: any) => (changeActiveTab(tab))
            }, [
              _createVNode(_unref(BaseIcon), {
                "icon-name": tab.iconName,
                "view-box": tab.iconViewBox || defaultViewBox
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon)))
                ]),
                _: 2
              }, 1032, ["icon-name", "view-box"])
            ], 10, _hoisted_5))
          }), 128))
        ])
      ])
    ], 2),
    _createVNode(_unref(AuthPopup), {
      message: _unref(trans)('live.modals.auth_action_tabs.message'),
      ref_key: "authPopupRef",
      ref: authPopupRef
    }, null, 8, ["message"])
  ], 64))
}
}

})